import { Injector, Optional, Pipe, PipeTransform } from '@angular/core';
import { DownloadService } from '@gsp-svc/formdoc-upload';
import { BasePathService } from '@farris/rtf';
@Pipe({ name: 'imageIdToUrl' })
class ImageIdToUrlPipe implements PipeTransform {
  private defaultPic = BasePathService.convertPath('/platform/common/web/assets/imgs/no-pic.png');
  private downloadService: DownloadService;
  constructor(@Optional() private injector: Injector) {
    this.downloadService = this.injector && this.injector.get<DownloadService>(DownloadService, null) || null;
  }

  transform(value: string, rootId: string = 'default-root'): string {
    if (!value) {
      return this.defaultPic;
    }
    // const rootId = 'default-root';
    if (this.downloadService) {
      return this.downloadService.getDownloadUrl(value, rootId);
    } else {
      console.warn('å å®å¨é®é¢ï¼éä»¶ä¸è½½æä¾å®å¨æ ¡éªæºå¶ï¼éä»¶ä¸è½½åè½ééæ°ç¼è¯ã');
      return BasePathService.convertPath(`/api/runtime/dfs/v1.0/formdoc/download/${value}`);
    }
  }
}

export { ImageIdToUrlPipe };
